import { createStore } from 'effector';

export const $chatHexagons = createStore({});
$chatHexagons.watch((state) => console.log('$chatHexagons', state));
